<template>
    <a-spin :spinning='confirmLoading'>
        <div class='main-box' style='border: 1px solid #EFEFEF'>
          <div class='be_choose_crf'>
            <a-table :columns='columns'
                     :dataSource='formList'
                     :loading='confirmLoading'
                     :pagination='false'
                     rowKey='id'
                     size='small'>
              <span slot="action" slot-scope="text, record,index">
                <a @click="removeByIndex(index)">删除</a>
              </span>
                <span slot="group" slot-scope="text, record">
              <a-select v-model=' record.groupId' style="width: 100%" allowClear>
                <a-select-option v-for="group in formGroupList" :value="group.id" :key="group.id">{{group.name}}</a-select-option>
              </a-select>
              </span>
                <span slot="sortNum" slot-scope="text, record">
                <a-input-number v-model="record.sortNum" :min="0" :precision="0" style="width: 100%" placeholder="请输入排序" />
              </span>
              <span slot="exclusionCondition" slot-scope="text, record, index">
                <a-select v-model="record.exclusionId"  placeholder="请选择规则" style="width: 100%"  show-search allowClear :filter-option="filterOptionTip">
                  <a-select-option
                    v-for="(item,index) in formExclusionList"
                    :key="index"
                    :value="item.id">                      
                    <a-tooltip :title="item.description">
                      {{ item.description }}
                    </a-tooltip>
                  </a-select-option>
                </a-select>
              </span>
            </a-table>
          </div>
        </div>
      <div style="float: right;">
        <a-button type="primary" @click="handleOk" icon="search">确定</a-button>
      </div>
  </a-spin>
</template>

<script>
  import baseRules from '@/constants/baseRules'
  import { getAction,postAction,deleteAction } from '@/api/manage'
  import {CACHE_PROJECT_ID} from '@/constants/project'
  import Vue from 'vue'
  export default {
    name: 'CsimVisitSelectedFormList',
    components: {  },
    props: {
      formList: {
        type: Array,
        required: false
      }
    },
    data() {
      return {
        projectId: Vue.ls.get(CACHE_PROJECT_ID),
        title: '表单选择',
        confirmLoading: false,
        isEdit: true,
        rules:{
          name:[baseRules.required],
          sortNum:[baseRules.required],
        },
        formGroupList:[],
        formExclusionList:[{"id":'0',"description":"无"}],//表单排除录入条件，来自质疑配置规则数据
      }
    },
    computed: {
      columns() {
        const operate = {
          title: '操作',
          align: 'center',
          width: 80,
          scopedSlots: { customRender: 'action' },
      }
        const columns = [
          {
            title: '排序',
            align: 'sortNum',
            scopedSlots: { customRender: 'sortNum' },
            width: 70
          },
          {
            title: '表单',
            dataIndex: 'formName',
            align: 'center',
            ellipsis: true
          },
          {
            title: '分组类型',
            // dataIndex: '分组类型',
            align: 'center',
            width: 130,
            scopedSlots: { customRender: 'group' },
          },
          {
            title: '不填写条件',
            // dataIndex: '分组类型',
            align: 'center',
            width: 260,
            scopedSlots: { customRender: 'exclusionCondition' },
          },
        ]
        if (!this.readonly) {
          return [...columns, operate]
        }
        return columns
      },
      existIdList(){
        return this.formList.map(item=>item.formId)
      }
    },
    created() {
      this.loadForm()
    },
    methods: {
      loadForm(){
        getAction('/project/projectVisitFormGroup/list',{projectId:this.projectId}).then(res=>{
          if(res.success){
            this.formGroupList = res.result
          }
        });
        this.getFormExclusionList()
      },
      handleOk() {
          this.submit()
      },
      submit(){
        let error = false
        this.formList.forEach(item=>{
          if(!item.sortNum){
            error= true
          }
        })
        if(error){
          return this.$message.warning('请填写排序字段')
        }
        this.confirmLoading = true
        postAction('/project/projectVisit/saveOrUpdate',{
          formList: this.formList,
        }).then(res=>{
          if(res.success){
            this.$message.success(res.message)
            this.close()
          }
        }).finally(()=>{
          this.confirmLoading= false
        })
      },
      handleCancel() {
        this.close()
      },
      addFormListHandle(record){
        const that = this
        if(this.formList.filter(item=>item.formId===record.id).length>0){
          return this.$message.warning('重复添加')
        }
        record.sortNum = record.sortNum || 1
        this.formList.push({
          sortNum:1,
          formId:record.id,
          formName:record.name
        })
      },
      removeByIndex(index){
        this.formList.splice(index,1)
      },
      addFormList(){
        this.formListVisible = true
      },
      getFormExclusionList(){
        var params = {"projectId":this.projectId,"pageSize":1000,"type":"3"};//查询其他规则的质疑     
        this.formExclusionList=[{"id":'0',"description":"无"}]   
        getAction('/project/projectSysQuestion/list', params).then((res) => {
          if (res.success) {
            this.formExclusionList.push(...(res.result.records || res.result))
          }
          if(res.code===510){
            this.$message.warning(res.message)
          }
        })
      },
      filterOption(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
      filterOptionTip(input, option) {
        return option.componentOptions.children[0].componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
    }
  }
</script>

<style lang='less' scoped>
  .visit_name_row {
    margin-bottom: 8px;
  }
  .main-box {
    padding: 12px;
  }

  /deep/ .ant-table-small > .ant-table-content > .ant-table-body > table > .ant-table-tbody > tr > td  .ant-select-selection {
    border: 0!important;
  }
</style>
